import { render, staticRenderFns } from "./advertisement-fees.vue?vue&type=template&id=484ee78e&scoped=true"
import script from "./advertisement-fees.vue?vue&type=script&lang=js"
export * from "./advertisement-fees.vue?vue&type=script&lang=js"
import style0 from "./advertisement-fees.vue?vue&type=style&index=0&id=484ee78e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484ee78e",
  null
  
)

export default component.exports